var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var SvgSearch = function SvgSearch(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.659 21.015l-2.708-2.71a5.985 5.985 0 00-1.18-7.948 5.977 5.977 0 00-8.02.396 5.985 5.985 0 00-.393 8.025 5.977 5.977 0 007.944 1.178l2.708 2.708a1.18 1.18 0 001.649 0 1.167 1.167 0 000-1.65zm-7.675-10.258a4.228 4.228 0 014.227 4.229 4.228 4.228 0 11-4.227-4.229z",
    fill: "#0D0C21",
    fillRule: "evenodd"
  })));
};

export default SvgSearch;